module.exports = __webpack_public_path__ + "static/item3-1c62e4e47c7576311138f1e5530f70be.svg";